/* global debounce */

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.js-search-input');
      this.form = this.closest('form');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = document.getElementById('product_type_input');
      this.resetBtn = this.querySelector('.js-search-reset');
      this.inputHandler = debounce(this.handleInput.bind(this));
      this.submitHandler = this.handleSubmit.bind(this);
      this.productTypeChangeHandler = this.handleProductTypeChange.bind(this);
      this.resetHandler = this.handleReset.bind(this);
      this.addListeners();
    }

    disconnectedCallback() {
      this.input.removeEventListener('input', this.inputHandler);
      if (this.productTypeSelect) {
        this.productTypeSelect.removeEventListener('change', this.productTypeChangeHandler);
      }
      if (this.form && !this.closest('predictive-search')) {
        this.form.removeEventListener('submit', this.submitHandler);
      }
      this.resetBtn.removeEventListener('click', this.resetHandler);
    }

    addListeners() {
      this.input.addEventListener('input', this.inputHandler);
      if (this.productTypeSelect) {
        this.productTypeSelect.addEventListener('change', this.productTypeChangeHandler);
      }
      if (this.form && !this.closest('predictive-search')) {
        this.form.addEventListener('submit', this.submitHandler);
      }
      this.resetBtn.addEventListener('click', this.resetHandler);
    }

    /**
     * Handles 'input' events on the search field.
     */
    handleInput() {
      if (this.input.value.length > 0) {
        this.input.classList.add('search__input--dirty');
      } else {
        this.input.classList.remove('search__input--dirty');
      }
    }

    /**
     * Handles search form submit.
     */
    handleSubmit() {
      this.input.value = theme.search.normalizeSearchTerm(this.input.value);
    }

    /**
     * Handles a change of product type
     * @param {object} evt - Event object.
     */
    handleProductTypeChange(evt) {
      this.productTypeInput.value = evt.detail.selectedValue;
    }

    /**
     * Handles the reset button being clicked
     */
    handleReset() {
      this.input.classList.remove('search__input--dirty');
    }
  }

  customElements.define('search-form', SearchForm);
}
